<div class="no-access-container d-flex flex-column justify-content-center align-items-center text-center">
    <i class="fa-solid fa-ban no-access-icon"></i>
    <h2 class="mt-3">Accesso negato</h2>
    <p class="lead mt-2">Non hai i permessi per accedere a questa app</p>
    <button type="button" class="btn btn-outline-secondary mt-3" (click)="logout()">
        <i class="fa-solid fa-right-from-bracket me-2"></i>Logout
    </button>
</div>
